// =========================================================================
// Kaituo CUSTOM SCRIPTS
// 1. Scroll Animation
// 2. Back to Top Button
// =========================================================================

document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.scroll-animate');
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
  
      animatedElements.forEach(el => {
        observer.observe(el);
      });
    } else {
      animatedElements.forEach(el => {
        el.classList.add('is-visible');
      });
    }
    const backToTopButton = document.querySelector('.back-to-top');
  
    if (backToTopButton) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > 300) {
          backToTopButton.classList.add('is-visible');
        } else {
          backToTopButton.classList.remove('is-visible');
        }
      });
  
      backToTopButton.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  });